// Children
import actionPlan from './action-plan/action-plan';
import coachView from './coach-view/coach-view';
import cvc from './cvc/cvc';
import engagement from './engagement/engagement';
import feedForward from './feed-forward/feed-forward';
import lga from './lga/lga';
import myCoach from './my-coach/my-coach';
import processStatus from './process-manager/process-manager';
import pulse from './pulse/pulse';
import supporter from './supporter/supporter';

export default {
  // Children
  ...actionPlan,
  ...coachView,
  ...cvc,
  ...engagement,
  ...feedForward,
  ...feedForward,
  ...lga,
  ...myCoach,
  ...processStatus,
  ...pulse,
  ...supporter,
};
